export const ROUTE_PATH_LandingPage = "/";
export const ROUTE_PATH_ProductListPage = "/products";
export const ROUTE_PATH_ProductListPage_Search = "/products/search";
export const ROUTE_PATH_ProductContentPage = "/product/:id";
export const ROUTE_PATH_WishListPage = "/wishlist";
export const ROUTE_PATH_CartPage = "/cart";
export const ROUTE_PATH_Unknown = "*";
export const ROUTE_PATH_LoginPage = "/login";
export const ROUTE_PATH_SignupPage = "/signup";
export const ROUTE_PATH_ProfilePage = "/profile";
export const ROUTE_PATH_Mockman = "/mockman";

export const VAR_ENCODE_TOKEN = "FeetzToken";
export const VAR_USER_ID = "FeetzUserId";
export const VAR_USER_DETAILS = "FeetzUserDetails";  